module.exports = __webpack_public_path__ + "assets/media/lunch.571ae72b.mp3";